<template>
    <v-card class="acknowledge-popup business-tnc">
        <v-flex class="banner_view__options__join__popup__title" text-xs-left >{{'Please acknowledge the following'}}
            <v-btn flat icon @click="closeTermsandConditions()" data-qe-id="close_terms-and-condition_btn">
            <i data-v-208291ac="" class="far fa-times-circle"></i>
            </v-btn>
        </v-flex>
        <v-flex class="card-body inner-scrollbar" data-qe-id="terms-and-condition_btn">
            <p><strong>RULES OF ENGAGEMENT</strong></p>
          <div>
            <ol>
              <li>The Business Marketplace with related links and access to third party platforms has been set up
                to help members do business (members discuss or participate in business or financial
                opportunities, offerings, investments promotions, discussions, or information). I agree and
                understand that my participation in the Business Marketplace is my affirmative consent to
                receive certain types of solicitation messages.
              </li>
              <li>
                I further understand that members are permitted to use the Business Marketplace discussion
                board for potential customers, distributors, franchising arrangements, licensing arrangements,
                purchase and sales of goods, provision of services.
              </li>
              <li>
                I accept that no offering of any securities or similar investment opportunities may be made in
                the Business Marketplace or at a Business Marketplace event or activity. Securities offerings
                may be made only in transactions registered under applicable foreign, federal, and/or state
                securities laws or that are exempt therefrom. Members should consult their own counsel
                regarding any obligations under foreign, federal, and state securities laws, including those laws
                and regulations related to securities offerings and applicable to SEC-registered reporting
                companies, broker-dealer, and investment advisor requirements.
              </li>
              <li>
                I understand that YPO provides no oversight, performs no review regarding the quality or
                accuracy of any information, and assumes no responsibility for the information presented in the
                Business Marketplace or at any related events or activities.
              </li>
              <li>
                I respect YPO’s Community Standards and value peer relationships over transactions. I agree to
                proactively disclose actual or potential conflicts of interest when engaging with others within
                the Business Marketplace.
              </li>
            </ol>
            <p class="pt-2">I understand that any compliance issues and violations will be reviewed by the Networks
              Conduct Committee.</p>
          </div>

          <div class="pt-2">
            <strong>YOU ACKNOWLEDGE AND AGREE TO THESE TERMS AND CONDITIONS (“TERMS”) AND REPRESENT IN
              THE AFFIRMATIVE THE STATEMENTS AND REPRESENTATIONS YOU MAKE HEREIN.
            </strong>
          </div>

          <div class="pt-2">
            YPO, Inc. (“YPO”) provides these Terms to its members (“Members”) participating in the Business
            Marketplace and the programs, offerings, and websites on or linked to the Business Marketplace or
            otherwise on the YPO Exchange or Connect. The term “Business Marketplace” means the website offering
            titled “YPO Business Marketplace” or similar title and includes an aggregation of communities, links to
            YPO networks and groups, programs and materials from YPO and third parties, platforms for engagement,
            and other components of the YPO platform intended to facilitate easier and more meaningful
            opportunities to learn and connect to help members do business. Given the nature of the Business
            Marketplace, YPO wants to make sure you understand your responsibilities and the potential risks, issues,
            and limitations involved in its activities and communications.
          </div>

          <div class="pt-3">
            <p>
              <strong>I. TERMS APPLICABLE TO ALL BUSINESS MARKETPLACE PARTICIPATION</strong>
            </p>
            <div><strong>Confidentiality:</strong></div>
            <div>
              During your involvement in the Business Marketplace, you may learn confidential information about other
              Members and their businesses and personal matters, including contact information, financial statements,
              strategies, strengths, and weaknesses. If that information is communicated outside YPO, there could be
              irreparable business and personal harm. You agree to maintain such information in strict confidence and
              not disclose such information to anyone outside YPO. You further agree not to use any such information
              learned during the course of your involvement the Business Marketplace for any personal or business gain
              that is directly detrimental to the personal or business affairs of the Member(s) who disclosed the
              information.
            </div>
            <div class="pt-2"><strong>Information in the Business Marketplace is the Responsibility of Members:</strong></div>
            <div>
              All information presented in the Business Marketplace or at Business Marketplace activities, including
              discussion board postings, messages, meetings, presentations, speeches, documents, offerings,
              opportunities, and all other communications (collectively, “Information”) are entirely the responsibility
              of the Member providing the Information. YPO provides no oversight, performs no review regarding the
              quality or accuracy of any Information, and assumes no responsibility for the Information presented in
              the Business Marketplace or at any related events or activities.
            </div>
            <div class="pt-2"><strong>Solicitation Agreement; Business Marketplace Communications:</strong></div>
            <p>The Business Marketplace has been set up to help members do business. You agree and understand that
              your participation in the Business Marketplace is your affirmative consent to receive certain types of
              solicitation messages. In particular, Members are permitted to use Business Marketplace discussion
              boards or similar platforms such as the YPO Opportunity Hub (previously YPO Transaction Hub) to offer
              their products, services, business needs or leads, and otherwise explore other potential business
              opportunities. Members offering goods and services or seeking other opportunities are reminded to
              value the relationship over the transaction. However, direct solicitation communications to members
              outside of the Business Marketplace platforms (i.e., through email, text, social media, etc.) is not
              permitted and subject to YPO’s Non-Solicitation Policy. Members should proactively disclose actual or
              potential conflicts of interest when engaging with others within the Business Marketplace.</p>
          </div>

          <div class="pt-3">
            You understand and agree that YPO does not endorse any products or services or any offerings on the
            Business Marketplace, nor does it create or develop information on its networks, groups, or in the
            Business Marketplace. YPO only passively displays the information shared by other individuals. YPO
            does not provide analysis of the propriety of the information, the suitability or performance of any
            opportunities presented, or the reputation or acumen of individuals involved. Careful diligence is highly
            advised. Further, sharing information displayed on the Business Marketplace or any other YPO platform
            to individuals outside of YPO is prohibited.
            <p>The following are examples of permitted and prohibited use of the Business Marketplace:</p>
          </div>

          <div class="pt-1">
            <div class="table-view">
              <div class="table-view__header">Acceptable Use </div>
              <div>
                <ul>
                  <li>Business questions, needs, or advice
                    (diligence, structuring, intelligence, resources)
                    for broader & centralized discussions
                  </li>
                  <li>Member products and services may be
                    offered and explored
                  </li>
                  <li>Request for connecting with other Members
                    or company contacts
                  </li>
                  <li>Promoting events that are hosted or co-hosted by the Business Marketplace</li>
                  <li>Knowledge documents, resources, tools, and
                    videos to help members do business
                  </li>
                  <li>Job opportunities for self may be made via the
                    Career Transitions community (link on page)
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="pt-2">
            <div class="table-view">
              <div class="table-view__header">Unacceptable Use </div>
              <div>
                <ul>
                  <li>Postings not related to the purpose, mission or scope of the Business Marketplace</li>
                  <li>Promotion of Chapter events not co-hosted by the Business Marketplace</li>
                  <li>Postings related to non-YPO or member-owned events</li>
                  <li>Requests for reservations, tickets, or access to recreational events</li>
                  <li>Offering of any securities or similar investment opportunities.</li>
                </ul>
              </div>
            </div>
          </div>

          <div class="pt-3">
            <p class="text-underline"><strong>YOUR WAIVER AND RELEASE OF LIABILITY:</strong></p>
            <div>
              In consideration of YPO facilitating my participation in the Business Marketplace, <strong>I HEREBY WAIVE ALL
              RIGHTS</strong> I may now have or that may accrue in the future against YPO, its respective chapters, regions,
              networks, affiliated entities, directors, officers, employees, agents, representatives, and members or
              member-spouses acting on behalf of or in furtherance of YPO’s objectives (collectively the “YPO
              Representatives”) and <strong>I HEREBY RELEASE AND DISCHARGE</strong> the YPO Representatives from, and agree to
              indemnify and hold the YPO Representatives harmless from and against all liability for, any actions,
              damages, causes of action, suits, costs, losses, expenses, claims, demands, damages, and judgments that
              I, my spouse, family members, children, invitees, heirs, executors, administrators, successors, assignees,
              employees, agents, and representatives ever had, now have, or hereafter shall or may have resulting from
              or in any way relating to my participation in the Business Marketplace, travel to and from a Business
              Marketplace event or activity, and any related activities or discussion related to the Business Marketplace
              (collectively, the “Losses and Claims”). For the avoidance of doubt, this release, discharge, and indemnity
              in favor of the YPO Representatives includes all present and future Losses and Claims for breach of
              contract, breach of express and/or implied warranty, breach of fiduciary duty, tortious interference with
              contractual relationships, tortious interference with prospective business relationships, misrepresentation, negligence, negligent misrepresentation, gross negligence, negligent or intentional
              infliction of emotional distress, bad faith, fraud, strict liability, strict products liability, and/or any statutory
              strict liability. I acknowledge that no promises, representations, or affirmations of fact were made to me
              by a YPO Representative concerning participating in any activity, academy, event, or outing related to,
              associated with, or connected in any way to the Business Marketplace. I affirm that I have read and
              understand the foregoing provisions of this waiver and release of liability and accept these terms as a
              condition of my attendance at any Business Marketplace activity, event, meeting, or related interaction. I
              further agree that this waiver and release is governed by the laws of the State of Texas, U.S.A, regardless
              of my domicile or residence.
            </div>
          </div>

          <div class="pt-3">
            <div><strong>Your Agreement Not to Publish Improper or Objectionable Information:</strong></div>
            <div>You agree and understand that You will not share offensive, illegal, inaccurate, false, improper, obscene,
              lewd, lascivious, filthy, violent, harassing, or otherwise objectionable information (collectively,
              “Objectionable Information”) in the Business Marketplace or at Business Marketplace activities. To
              regulate the dissemination of Objectionable Information over the Business Marketplace, YPO maintains
              the right, but not the duty, to exercise its editorial and self-regulatory functions by withdrawing,
              removing, editing, or altering Objectionable Information that is posted on the Business Marketplace. You
              agree and understand, however, that YPO may not actively monitor the Business Marketplace for
              Objectionable Information, and as a result, Objectionable Information may or may not be withdrawn,
              deleted, edited, or altered by YPO.
            </div>
          </div>

          <div class="pt-3">
            <strong>
              II. TERMS APPLICABLE TO MARKETPLACE ACTIVITY INVOLVING BUSINESS OR FINANCIAL
              OPPORTUNITIES, OFFERINGS, INVESTMENTS, PROMOTIONS, DISCUSSIONS, AND
              INFORMATION, INCLUDING THE YPO OPPORTUNITY HUB OR YPO NETWORKS
            </strong>
          </div>

          <div class="pt-3">
            <div><strong>Restrictions Relating to Securities:</strong></div>
            <div>
              No offering of any security may be made in the Business Marketplace or at a Business Marketplace event
              or activity. Securities offerings may be made only in transactions registered under applicable foreign,
              federal, and/or state securities laws or that are exempt therefrom. With respect to relevant descriptions,
              Members should consult their own counsel regarding any obligations under foreign, federal, and state
              securities laws, including those laws and regulations related to securities offerings and applicable to SEC-registered reporting companies, broker-dealer, and investment advisor requirements. YPO and YPO’s
              counsel do not represent Members. Members must not rely on any statements from YPO or YPO’s
              counsel regarding a Member’s potential compliance with applicable law.
            </div>
          </div>

          <div class="pt-3">
            <div><strong>Eligibility:</strong></div>
            <div>
              The Business Marketplace may include links or access to YPO networks and groups (collectively,
              “Networks”) or third-party platforms where members discuss or participate in business or financial
              opportunities, offerings, investments promotions, discussions, or information, including in the Deal
              Network and YPO Opportunity Hub. These Networks and platforms are available only to active Members
              who are in good standing and who (1) have financial and business knowledge and experience that reflect
              an ability to effectively evaluate information and opportunities that may be presented or discussed, (2)
              are “accredited investors,” as described below, (3) meet on a continuing basis YPO's quantitative and
              qualitative personal and membership requirements, and (4) have affirmatively indicated interest in
              participation. These Networks and platforms are for the private use of these qualified Members to
              facilitate communications and information among themselves, and information and opportunities
              discussed therein may not be further disseminated or passed to non-Members. YPO collects no fee and is
              not compensated for providing these platform opportunities. Members may not post information or
              opportunities for third parties, or be compensated for providing information or opportunities posted in
              the Business Marketplace or the Networks, unless they are licensed professionals in compliance with
              applicable law.
            </div>
          </div>

          <div class="pt-4">
            In participating in these business or financial matters, including the Business Marketplace, Deal Network,
            or YPO Opportunity Hub, it is important to understand that: (1) the individual Members willingly share
            Information; (2) Information is provided and generated by the individual Members, not YPO;
            (3) Information originates with the individual Members, not YPO; (4) the individual Members are
            responsible for the creation and development of Information; (5) YPO is not responsible for the creation
            or development of Information; (6) YPO does not contribute to the creation or development of
            Information; (7) Information is in no way elicited, induced, or encouraged by YPO; (8) YPO may passively
            display certain Information for Members, and if it does, YPO is merely an intermediary and conduit of such
            Information; (9) YPO is not the publisher or speaker of Information; (10) YPO provides no analysis, advice,
            approval, or recommendation regarding any Information or opportunity discussed in or related to the
            Business Marketplace or Network; and (11) YPO accepts no responsibility to verify that any Member is an
            “accredited investor.”
          </div>

          <div class="pt-3">
            <p><strong>Specific Information and Regarding the YPO Opportunity Hub and Opportunity Network:</strong></p>
            <p>The Business Marketplace provides access the Opportunity Network, which is a third-party service
              provider that hosts and operates certain electronic capabilities for YPO, including hosting and operating
              the YPO Opportunity Hub. Pursuant to its agreement with YPO, Opportunity Network hosts and makes its
              platform available to Members to interact with other Members inside of YPO or with non-Members
              outside of YPO. Opportunity Network is a third-party website (and NOT a YPO website). To access the
              Opportunity Network platform (including the YPO Opportunity Hub), you must first agree to Opportunity
              Network’s terms and conditions. Consequently, all Information you provide using the Opportunity
              Network platform (including YPO Opportunity Hub) is provided to Opportunity Network and is outside
              YPO’s control, and that Information is subject to Opportunity Network’s terms and conditions, including
              how Opportunity Network uses that information. After agreeing to Opportunity Network’s terms and
              conditions, you will have the option to choose whether to share certain Information with only Members,
              or both with Members AND a broader audience of non-Members who also use the Opportunity Network
              platform. As part of the Opportunity Network platform (and YPO Opportunity Hub), you agree to receive
              solicitations from other Members regarding business transactions and opportunities. Please remember to
              review your options on YPO Opportunity Hub.
            </p>
            <div>
              <img src="../../assets/businessMarketImg.png" style="height: 100px; width: 90%" alt="business_img">
            </div>
          </div>

          <div class="pt-3 bold-font text-underline">
            You hereby acknowledge that each of the following statements is true and correct and you make such
            statements and representations in the affirmative without reservation:
          </div>

          <div>
            <ul>
              <li>
                You understand and accept the terms, conditions, responsibilities, risks, and limitations of
                participation in the Business Marketplace and all Business Marketplace activities, and related
                communications and interactions as a continuing condition of participation in the Business
                Marketplace.
              </li>
              <li>
                If you are providing or participating in the exchange of business or financial opportunities, offerings,
                investments, promotions, discussions, or information, you are an accredited investor and confirm that
                you have the knowledge and experience in financial and business matters to evaluate the information
                and opportunities that may be made available through participation in the Business Marketplace or
                any Business Marketplace activities. As an example, as of the date of these terms, SEC Rule 501 of
                Regulation D defines an accredited investor as an individual with a net worth of $1,000,000 or income
                of $200,000 for the past two years or spousal joint income of $300,000 for the past two years and an
                expectation of the same income in the current year. See Rule 501(a) and any amendments for
                additional detail and other requirements for accredited investors.
              </li>
              <li>
                You understand that Information may be confidential and not publicly available, and you will treat
                such Information pursuant to the confidentiality obligations above.
              </li>
              <li>
                You have read and understood YPO’s
                <a class="link-element" href="https://www.myypo.org/MyYPO/Assets/Files/Networks/DEALNETWORK/AntitrustComplianceManualAug2005.pdf" target="_blank">Antitrust Statement</a>
                and agree to its terms.
              </li>
              <li>
                If you are a licensed securities or investment professional, you will disclose that fact and whether you
                are being or may be compensated in connection with any offering, opportunity, or related
                communication made in the Business Marketplace. You also acknowledge and represent that you
                have complied with all reporting obligations to applicable securities and investment regulators.
              </li>
            </ul>
          </div>

          <div class="pt-4 bold-font text-underline text-center">YPO ANTITRUST STATEMENT</div>
          <div class="pt-2">
            YPO, Inc. (“YPO”) is committed to complying fully with the letter and spirit of all applicable domestic and
            international antitrust and trade regulation laws. The information contained herein has been prepared by
            YPO as a service to its members. This Antitrust Statement does not constitute legal advice and shall not
            be construed as the rendering of legal services. YPO does not guarantee its members immunity from
            potential antitrust and trade regulation laws. Members should not rely solely on the information
            contained herein, and should seek the services of legal counsel as needed.
          </div>
          <div class="pt-2">
            YPO provides this Antitrust Statement to its members (“Members”) who wish to participate in any of the
            chapters, networks, sub-networks, groups, regions, events, programs, activities, experiences, forums,
            conferences, and other opportunities (collectively, the “Activities”). The purpose of this Antitrust
            Statement is to inform all Members of the potential antitrust risks associated with the Activities and
            related communications. When participating in the Activities, all Members should act in accordance with
            the antitrust compliance guidelines provided herein. Members who fail to comply may be subject to
            penalty, including, but not limited to, expulsion from YPO. Management team members who fail to comply
            are subject to disciplinary action, including possible termination.
          </div>
          <div class="pt-3">
            <p class="bold-font">I. ANTITRUST LAWS</p>
            <p>
              Through its Activities, YPO provides a platform where Members from different industries, business, and
              experiences come together in idea exchange. A product of this broad interaction among Members is an
              opportunity for anticompetitive conduct in violation of U.S. federal and state laws and non-U.S. laws
              (collectively, “antitrust laws”). The antitrust laws are intended to promote vigorous competition and
              protect consumers from anticompetitive business practices. In particular, interactions between Members
              who are potential or actual competitors in the same industry carry the highest risk of implicating the
              antitrust laws. While there is no universal set of antitrust laws that would apply to every interaction in
              every country, there is a principal set of laws in the United States, European Union, and the United
              Kingdom that provide a comprehensive overview of expected interactions at all times, such as:
            </p>
          </div>
          <div class="pt-2">
            <p class="bold-font text-underline">Principal U.S. Antitrust Statutes </p>
            <div>
              <ul>
                <li>
                  <strong>The Sherman Act</strong> prohibits "contracts, combinations and conspiracies in restraint of trade" and
                  prohibits illegal monopolization, attempts to monopolize, and conspiracies to monopolize in any line
                  of commerce. The Sherman Act further prohibits the abuse or attempted abuse of a dominant market
                  position. For example, a manufacturer that is not a monopolist or seeking to become one may
                  nonetheless violate the Sherman Act if its customers influence its decision over competing customers.
                </li>
                <li>
                  <strong>The Clayton Act</strong> prohibits mergers or acquisitions that may "substantially lessen competition" or
                  "tend to create a monopoly" in any line of commerce. The Act also makes it unlawful to sell or lease
                  commodities on the condition that the buyer or lessee refuses to deal in the goods of a competing
                  seller when the effect of such a sale or lease may be to substantially lessen competition or tend to
                  create a monopoly in any line of commerce. Subject to the “rule of reason” (discussed below),
                  exclusive dealing arrangements are prohibited when they adversely affect competition. A grant of an
                  exclusive territory by a manufacturer to a dealer may be lawful if it involves no more than a pledge
                  not to appoint another dealer whose premises are physically located within the first dealer's territory.
                  But, in some circumstances, it is illegal to prevent dealers located in one territory from making sales
                  in another. Further, reciprocal dealing, particularly true if the reciprocity is coercive or part of a
                  process of exploiting buying or selling power, may also violate the antitrust laws.
                </li>
                <li>
                  <strong>The Federal Trade Commission Act</strong> prohibits unfair methods of competition and unfair or deceptive
                  acts or practices in or affecting commerce. This Act allows the Federal Trade Commission to enjoin
                  potentially anti-competitive conduct before it can ripen into a violation of other U.S. antitrust laws.
                </li>
                <li>
                  <strong>The Robinson-Patman Act</strong> generally restricts price discrimination by a seller among different similarly
                  situated purchasers who are in competition (or whose customers are in competition). This Act also
                  covers indirect discrimination through the unequal allocation of promotional services or allowances.
                </li>
              </ul>
            </div>
            <div class="pt-2">
              <p class="text-underline bold-font">
                Chief EU/UK Competition Provisions
              </p>
              <div>
                <ul>
                  <li>
                    <strong>Article 101</strong> of the Treaty on the Functioning of the European Union (“TFEU”) prohibits "all agreements
                    between undertakings, decisions by associations of undertakings and concerted practices which may
                    affect trade between member States and which have as their object or effect the prevention,
                    restriction or distortion of competition within the internal market." The effect on trade can be actual
                    or potential. Examples of prohibited conduct include direct or indirect price fixing, restricting or
                    limiting production, combining market share and applying unequal conditions to equivalent
                    transactions with trading parties. This provision is similar to Section 1 of the Sherman Act.
                  </li>
                  <li>
                    <strong>Article 102</strong> of the TFEU prohibits "abuse by one or more undertakings of a dominant position within
                    the internal market or in a substantial part of it." This includes "directly or indirectly imposing unfair
                    purchase or selling prices or other unfair trading conditions," "limiting production, markets or
                    technical development to the prejudice of consumers," "applying dissimilar conditions to equivalent
                    transactions with other trading parties, thereby placing them at a competitive advantage," and
                    “making the conclusion of contracts subject to acceptance by the other parties of supplementary
                    obligations which, by their nature or according to commercial usage, have no connection with the
                    subject of such contracts." Broadly speaking, Article 102 is similar to Section 2 of the Sherman Act.
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="pt-3">
            <p class="italic bold-font">Members Generally</p>
            <div>
              All Members should exercise caution when sharing non-public information with fellow Members (which
              includes Members’ guests, spouses/partners, and children), regardless of industry background. Non-public information includes, but is not limited to: information related to past, present, or future prices;
              pricing policies; bids; discounts; promotions; terms or conditions of sale; royalties; choice or
              creditworthiness of customers; choice of suppliers; allocation of territorial markets; and production or
              sales volume. Members are prohibited from engaging or participating in any form of bribery.
            </div>
          </div>
          <div class="pt-3">
            <p class="italic bold-font">Members from the Same Industry</p>
            <div>
              In addition to the general recommendation above, Members who compete in the same industry should
              be aware of the additional risks associated with collaborations and/or interactions between potential or
              actual competitors. In the EU/UK particularly, the mere exchange of competitively sensitive information
              between competitors may amount to impermissible behavior even in the absence of an agreement.<sup>1</sup>
              The
              antitrust laws address two forms of anticompetitive market restraint: vertical and horizontal. Vertical
              restraints involve restrictions between firms at different levels of the distribution chain (e.g., a
              manufacturer and a retailer). Typically, conduct involving vertical restraints is evaluated in the U.S. under
              a flexible ‘Rule of Reason’ analysis<sup>2</sup> and considered highly serious in the EU/UK.<sup>3</sup>
              Contrarily, horizontal
              restraints involving restrictions between firms who operate at the same level of the distribution chain
              (e.g., two manufacturers of the same product) are subject to harsher scrutiny and are generally deemed
              strictly illegal under the antitrust laws.<sup>4</sup>
              Such agreements may infringe the law even if they have not yet
              been implemented or had any material effect. The following are a few common examples of
              anticompetitive practices that are unlawful:
            </div>
            <div class="pt-2">
              <ul>
                <li>
                  It is illegal to use YPO as a platform to control or suggest industry prices. The antitrust laws strictly
                  prohibit the use of disguised means to fix prices. This may include information-sharing programs
                  between competitors, or agreements amongst industry members to adopt standardized terms or
                  contracts, accounting practices, or output<sup>5</sup>. Agreements of this nature between horizontal
                  competitors are per se unlawful. Competitors may not participate in any such arrangements.
                </li>
                <li>
                  Restricting distributors or suppliers by, for example, dictating resale prices or imposing prohibitions
                  on resale outside of certain territories or customers may be an improper vertical restraint on trade.
                </li>
                <li>
                  Marketing, research, development, and pricing collaborations between competitors may also violate
                  the antitrust laws and therefore should always be evaluated by independent antitrust counsel.
                </li>
                <li>
                  Further, any exchange of information between competitors may violate the antitrust laws if it results
                  in an increase of market power, artificial price raises, or reduction in overall product output.
                </li>
                <li>
                  Members should refrain from any “group boycotts,” which may occur when two or more Members
                  agree not to buy or sell to a particular seller or buyer. Competitors also should be cautious not to
                  exclude another competitor from industry associations, initiatives, and standard setting processes.
                </li>
              </ul>
            </div>
            <div class="pt-1">
              All Members should note that an agreement, collaboration, or conspiracy under the antitrust laws does
              not require a formal written contract. Informal understandings or tacit agreements (e.g., a nod or a wink)
              may constitute an agreement nonetheless. <strong>Informal discussions at an Activity, including, specifically,
              network or groups events, interactions, or related discussions,</strong> are subject to the guidelines herein.
            </div>
          </div>
          <div class="line-break mt-3 mb-2"></div>

          <div>
            <p>
              <sup>1</sup>The European Commission and EU/UK competition authorities scrutinize the activities of industry and professional
              associations closely given the heightened potential risk of anti-competitive conduct.
            </p>
            <p>
              <sup>2</sup>The “rule of reason” is a doctrine of antitrust law which holds that certain conduct in trade will violate the U.S. laws
              only if the practice is an unreasonable restraint of trade, based on various factors.
              3 Practices such as fixing a minimum resale price or imposing prohibitions on resale are treated more harshly in the
              EU and UK than in the U.S.
            </p>
            <p>
              <sup>3</sup> Practices such as fixing a minimum resale price or imposing prohibitions on resale are treated more harshly in the
              EU and UK than in the U.S
            </p>
            <p>
              <sup>4</sup>Horizontal agreements are considered per se illegal under U.S. law and “by object” illegal in the EU/UK. “By object”
              restrictions in the EU/UK refer to the most serious violations of competition law.
            </p>
            <p>
              <sup>5</sup>For additional relevant information, see the Federal Trade Commission’s “Spotlight on Trade Associations”:
              <a class="link-element" href="https://www.ftc.gov/tips-advice/competition-guidance/guide-antitrust-laws/dealings-competitors/spotlight-trade" target="_blank">https://www.ftc.gov/tips-advice/competition-guidance/guide-antitrust-laws/dealings-competitors/spotlight-trade.</a>
            </p>
          </div>

          <div class="pt-3">
            <p class="bold-font">II. GUIDELINES FOR COMMUNICATIONS BETWEEN MEMBERS </p>
            <p>The following are common “don’ts” that all Members should consider for their interactions in YPO:</p>
            <div class="pt-3">
              <ul>
                <li><strong>DON’T</strong> share or discuss specific cost or pricing information, including any elements of price or the
                  timing of pricing changes.
                <li><strong>DON’T</strong> share sensitive information regarding target consumers that is not publicly available to all
                competitors in the market.</li>
                <li><strong>DON’T</strong> divulge specific information regarding means of output.</li>
                <li><strong>DON’T</strong> share specific information related to distribution methods or networks.</li>
                <li><strong>DON’T</strong> collaborate with competitor Members to fix or otherwise control price, output, distribution,
                  or territory.</li>
                <li><strong>DON’T</strong> share information on current operating and future business plans or strategies.</li>
                <li><strong>DON’T</strong> share individual company data.</li>
                <li><strong>DON’T</strong> discuss market shares.</li>
                <li><strong>DON’T</strong> discuss markets or geographic territories to be served by you or other Members.</li>
                <li><strong>DON’T</strong> share company terms or conditions.</li>
                <li><strong>DON’T</strong> disclose information not previously released through securities filings or earnings releases
                  regarding the present, the projected, or the desired profitability of your products.</li>
                <li><strong>DON’T</strong> disclose information on specific tenders or bids.</li>
                <li><strong>DON’T</strong> sit idly by if someone in YPO is violating this policy. Request that any improper discussion end
                  and, if it persists, immediately disassociate yourself from the discussion and report it to YPO.
                </li>
              </ul>
            </div>
          </div>

          <div class="pt-2">
            <p class="bold-font">
              III. EXAMPLES OF ANTICOMPETITIVE CONDUCT
            </p>
            <div>
              <ul>
                <li>
                  While participating in a network event, a Member provides a copy of a document detailing his or her
                  company's imminent price increases to other Members in the same industry. He or she suggests or
                  implies that they follow suit. Within 30 days, all members who received the document increaseprices.
                  <span class="text-highlight">This conduct could constitute an unlawful combination, contract, or conspiracy in restraint of trade, in
                    violation of Section 1 of the Sherman Act and/or Article 101 of the TFEU</span>
                </li>
                <li>
                  A member posts on a network discussion board a complaint that foreign competition is "killing him."
                  The Member suggests that he concentrate his efforts on one region, another Member concentrate on
                  another region, and a third on yet another region. Those members then place appropriate bids in their
                  assigned regions and inflated bids in the others. The result is that the Members win bids in each of
                  their assigned regions. <span class="text-highlight">This conduct could constitute “bid rigging,” an unlawful combination, contract,
                  or conspiracy in restraint of trade, in violation of Section 1 of the ShermanAct and/or Article 101 of the
                  TFEU.</span>
                </li>
                <li>
                  While participating in an industry roundtable discussion, a Member expresses her dislike for a
                  materials supplier and suggests or implies that the other Members in her same industry cease doing
                  business with that supplier. The supplier subsequently loses the business of all the Members. <span class="text-highlight">This
                  conduct could constitute a group boycott, a per se unlawful combination, contract, or conspiracy in
                  restraint of trade, in violation of Section 1 of the ShermanAct and/or Article 101 of the TFEU.</span>
                </li>
                <li>
                  At a YPO global event, two Members that compete in the same industry set a meeting to discuss tips
                  and tools to better improve their respective businesses. Among other things, they discuss their cost
                  structures and external factors that affect their profitability, including specific dealings with
                  customers, suppliers, and vendors. <span class="text-highlight">The conduct could constitute an alleged combination, conduct or
                  conspiracy in restraint of trade, in violation of Section 1 of the Sherman Act and/or Article 101 of the
                  TFEU.</span>
                </li>
                <li>
                  These examples apply to all YPO Activities, and this list is not exhaustive.
                </li>
              </ul>
            </div>
          </div>
        </v-flex>
      <v-flex text-xs-center xs12>
        <v-btn class="primary_btn theme--light banner_view__options__join__popup__terms"
               data-qe-id="agree_terms-and-condition_btn"
               @click="displayEmailOptions()">I agree to the Terms and Conditions</v-btn>
      </v-flex>
    </v-card>
</template>

<script>
export default {
  name: 'BusinessMarketplaceGroupTermsAndConditions',

  methods: {
    displayEmailOptions() {
      this.$emit('close', true);
    },
    closeTermsandConditions() {
      this.$emit('close', false);
    },
  },
};
</script>
<style lang="scss">
@import "../../common/styles/_colors.scss";

.business-tnc {
  .table-view {
    border: 1px solid $ypo-blue;
    &__header {
      font-weight: 600;
      text-decoration: underline;
      background-color: $ypo-light-gray;
      padding: 3px;
    }
  }

  .line-break {
    height: 1px;
    width: 120px;
    background-color: black;
  }

  .text-highlight {
    color: $black;
    opacity: 0.8;
    font-style: italic;
  }
}
</style>
